import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { approveBadgeAssignment } from '../services/apiservice';
import { Card, Typography, Box, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ApproveBadgeAssignment = () => {
  const { assignmentIds } = useParams();
  const [statusMessage, setStatusMessage] = React.useState(null);
  const [isError, setIsError] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [isApproved, setIsApproved] = React.useState(false);
  const [notFound, setNotFound] = React.useState(false);
  const [notFoundMessage, setNotFoundMessage] = React.useState(null);

  useEffect(() => {
    const approvedAssignments = JSON.parse(localStorage.getItem('approvedAssignments')) || [];
    const assignmentIdsArray = assignmentIds.split('-').map(Number);

    const alreadyApproved = assignmentIdsArray.some(id => approvedAssignments.includes(id));
    if (alreadyApproved) {
      setNotFound(true);
      setNotFoundMessage('Oops! The badge assignment has already been approved.');
      setLoading(false);
      return;
    }

    const approveAssignment = async () => {
      try {
        const response = await approveBadgeAssignment({ assignmentIds: assignmentIdsArray });

        if (response.approvalStatus === 'already_approved') {
          setNotFound(true);
          setNotFoundMessage('Oops! The badge assignment has already been approved.');
          setLoading(false);
          return;
        }
        else if (response.approvalStatus === 'not_approved') {
          setNotFound(true);
          setNotFoundMessage(response.message);
          setLoading(false);
          return;
        }
        else if (response.approvalStatus === 'approved') {
          const updatedApprovedAssignments = [...approvedAssignments, ...assignmentIdsArray];
          localStorage.setItem('approvedAssignments', JSON.stringify(updatedApprovedAssignments));

          setStatusMessage('Badge assignment approved successfully!');
          setIsError(false);
          setIsApproved(true);
        } else {
          setStatusMessage('Error approving badge assignment.');
          setIsError(true);
        }
      } catch (error) {
        setStatusMessage('Error approving badge assignment.');
        setIsError(true);
        console.error('Error approving badge assignment:', error);
      } finally {
        setLoading(false);
      }
    };
    approveAssignment();
  }, [assignmentIds]);

  const renderLoading = () => <CircularProgress />;

  const renderApprovedCard = () => (
    <Card
      sx={{
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: 400,
        height: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#E0F7FA',
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <CheckCircleIcon sx={{ color: 'green', fontSize: 40, marginBottom: '10px' }} />
        <Typography variant="h4" sx={{ color: 'black', fontWeight: 'bold' }}>
          Approved!
        </Typography>
        <Typography variant="body1" sx={{ marginTop: '10px', color: 'black' }}>
          Thanks for approving the badge assignment.
        </Typography>
        <Typography variant="body1" sx={{ marginTop: '10px', color: 'black' }}>
          (You can close the window now)
        </Typography>
      </Box>
    </Card>
  );

  const renderNotFoundCard = () => (
    <Card
      sx={{
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: 500,
        height: '150px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#FFCCCB',
      }}
    >
      <Typography variant="h4" sx={{ color: 'black', fontWeight: 'bold' }}>
        Not Found
      </Typography>
      <Typography variant="body1" sx={{ marginTop: '10px', color: 'black' }}>
        {notFoundMessage}
      </Typography>
    </Card>
  );

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{ backgroundColor: '#f5f5f5' }}
    >
      {/* {loading ? renderLoading() : notFound ? renderNotFoundCard() : renderApprovedCard()} */}
      {loading ? renderLoading() : isApproved ? renderApprovedCard() : notFound ? renderNotFoundCard() : renderApprovedCard()}
    </Box>
  );
};

export default ApproveBadgeAssignment;
